import React, { ChangeEvent } from 'react';
import {IProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import Input from '@components/Input';

const TemplateName:React.FC<IProps> = (props) => {

  const handleChangeName = (e:any) => {
    if (props.files[props.currentIndex] && e.target) {
      updateName(e.target.value);
    }
  }

  const handleBlur = (e: ChangeEvent<HTMLInputElement>) => {
    if (props.files[props.currentIndex] && e.target) {
      updateName(e.target.value.trim());
    }
  }

  const updateName = (value: string) => {
    props.setFiles([
      ...props.files.slice(0, props.currentIndex),
      {...props.files[props.currentIndex], file: {...props.files[props.currentIndex].file, name: value}, renamed: true},
      ...props.files.slice(props.currentIndex + 1)
    ]);
  }

  return (
    <S.Root 
      style={{margin: props.fromEditTemplate && props.fromEditTemplate === true ? '0px 60px 0px 60px' : '0px 78px 0px 50px'}}
    >
      <S.Title>Title</S.Title>
      <Input 
        id={"template-name"}
        placeholder={"Template name"}
        value={props.files[props.currentIndex] ? props.files[props.currentIndex].file.name : ''}
        handleChange={(event:ChangeEvent<HTMLInputElement>) => handleChangeName(event)}
        handleBlur={handleBlur}
        disabled={!props.files[props.currentIndex]}
        tipLabel={props.tipLabel}
        tipLabelColor={props.tipLabelColor}
        style={{
          marginTop: '16px',
        }}
        inputStyle={{color: props.files[props.currentIndex]?.renamed ? C.BLACK : 'auto'}}
      />
    </S.Root >
  );
}

export default TemplateName;